module.exports = __webpack_public_path__ + "static/media/background_apprentissage.24642d46.png";